import React from 'react';
import MessagingRubric from '../MessagingRubric';
import MessagePreferencesForm from '../MessagePreferencesForm';

export default function Messaging() {
  return (
    <>
      <MessagingRubric />
      <MessagePreferencesForm />
    </>
  );
}
